/*
  stateful_module
*/
/**
 * STATEFUL MODULE
 * Manage stateful modules
 */

/************************************************
			INIT STATES
*************************************************/
//== states init
//== 0 => hide modules
var otb_state = 0;
var mmb_state = 0;
var cb_state  = 0;

//== try to get options from WL
var WL_states = $("input[data-type='benefit-state']");

//== go through these options if at least 1 available
//== this format must be respected : state-STATENAMEHERE
WL_states_nb  = WL_states.length;

if (WL_states_nb > 0) {
	WL_states.each(function() {
		var _this = $(this);
		var _val = $(this).val();
		var _name = $(this).attr("data-name");

		var state = _name.split("-");
		state = Array.isArray(state) ? state[1] : console.error("err - state found but incorrect format");

		//== assign state
		switch (state) {
			case "otb": otb_state = _val; break;
			case "mmb": mmb_state = _val; break;
			case "cb": cb_state = _val; break;
		}
	});
}
//-- manage CB states
else {
	/************************************************
		 GET ALL WL & CB STATE via bundle.js
		 method from bundle.js
	*************************************************/
	if (typeof group !== "undefined") { //group is from bundle.js, in group.js

		//-- extract CB value
		if (typeof CB_STATE !== "undefined" && CB_STATE) {
			cb_state = CB_STATE;
		}

		//-- extract OTB value
		if (typeof OTB_STATE !== "undefined" && OTB_STATE) {
			otb_state = OTB_STATE;
		}

		//-- extract MMB value
		if (typeof MMB_STATE !== "undefined" && MMB_STATE) {
			mmb_state = MMB_STATE;
		}
	}
}



/************************************************
			GO THROUGH ALL STATEFUL MODULES
*************************************************/
$("[data-type=module][data-state], [data-state-type][data-state]").each(function() {

	//== init
  var module = $(this);
  var show_module = false;
	var state_to_use = 0;

  //== get states and type
  var module_states = module.attr("data-state");
	var module_state_type = "";

	//== if module need specific state..
	if (module.is("[data-state-type]")) {
		module_state_type = module.attr("data-state-type");
	}
	//== else use the one of the page
	else {
		module_state_type = __PAGE_CODE;
		switch (module_state_type) {
			case "wrp": module_state_type = "otb";break;
			case "mbp": module_state_type = "mmb";break;
			case "cbp": module_state_type = "cb";break;
		}
	}


	module_states = module_states.split(",");
  module_states_nb  = module_states.length;

	//== check state to use
	switch (module_state_type) {
		case "otb": state_to_use = otb_state; break;
		case "mmb": state_to_use = mmb_state; break;
		case "cb": state_to_use = cb_state; break;
	}

  if (module_states_nb > 0) {
		for (var i = 0; i < module_states_nb; i++) {
		  if (module_states[i] == state_to_use) {
		    show_module = true;
		  }
		}
	}

	//== if module is available for the current state
	if (show_module) {

		//== show module
		module.show();

    //== get elements which will be affected by a state change
    var module_elements = module.find("[data-state]");

    //== go through these elements
    module_elements.each(function() {

	    //== init
			var show_it = false;
			var module_element = $(this);

			//== get element states where its displayed
			var el_states = module_element.attr("data-state");
			el_states = el_states.split(",");
			el_states_nb = el_states.length;

			//== go through these states
			if (el_states_nb > 0) {
				for (var i = 0; i < el_states_nb; i++) {
				  if (el_states[i] == state_to_use) {
				    show_it = true;
				  }
				}
			}

			//== if the element state match the module state, show it
			if (show_it) {
				module_element.show();
			}
    });
	}
	else {
		module.hide();
	}
});
